export default "__VITE_ASSET__CuGQtKON__"